import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { CircularProgress, Typography, Box } from '@mui/material';
import RatingService from './RatingService';
import debounce from 'lodash.debounce'; // npm install lodash

const formatCurrency = (value) =>
    new Intl.NumberFormat('tr-TR', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);


const MainMeterRatingCalculator = ({
    startDate,
    endDate,
    indexValues,
    mainMeterId,
    mainMeters,
    amount,
    setAmount,
    hasLoadedAmount
}) => {
    const [loading, setLoading] = useState(false);
    const [ratingResult, setRatingResult] = useState(null);
    const [debouncedValues, setDebouncedValues] = useState(indexValues);

    // Debounce işlemi
    useEffect(() => {
        const handler = debounce(() => {
            setDebouncedValues(indexValues);
        }, 600); // 600ms sonra tetikler

        handler();

        return () => handler.cancel();
    }, [indexValues]);

    useEffect(() => {
        if (ratingResult?.totalCharge != null) {
            setAmount(ratingResult.totalCharge);
        }
    }, [ratingResult, setAmount]);

    const buildRequest = () => {
        const selectedMainMeter = mainMeters.find(
            (meter) => meter.mainMeterId === parseInt(mainMeterId)
        );

        const indexConsumptionList = Object.entries(debouncedValues || {}).map(
            ([indexType, value]) => ({
                indexType,
                consumption: parseFloat(value || 0),
            })
        );

        if (selectedMainMeter?.contractPower > 0) {
            indexConsumptionList.push({
                indexType: 'P',
                consumption: selectedMainMeter.contractPower,
            });
        }
        return {
            startDate: dayjs(startDate).format('YYYY-MM-DD'),
            endDate: dayjs(endDate).format('YYYY-MM-DD'),
            tariffId: selectedMainMeter?.tariff?.tariffId,
            subsidized: selectedMainMeter?.subsidized,
            contractPowerChargeSharing: 'MAIN_METER_ONLY',
            exceededPowerChargeSharing: 'MAIN_METER_ONLY',
            mainMeterConsumptions: indexConsumptionList,
            subMeterConsumptions: [],
        };
    };

    const calculateRating = async () => {
        setLoading(true);
        try {
            const request = buildRequest();
            const response = await RatingService.rating(request);
            setRatingResult(response.data);
        } catch (error) {
            console.error('Rating hesaplama hatası:', error);
            setRatingResult(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {

        if(hasLoadedAmount ){
            return;
        }

        const isValidInput =
            startDate &&
            endDate &&
            Object.values(debouncedValues || {}).some((val) => parseFloat(val) > 0) &&
            mainMeterId;

        if (isValidInput) {
            calculateRating();
        } else {
            setRatingResult(null);
            setAmount(null);

        }
    }, [startDate, endDate, debouncedValues, mainMeterId]);

    return (
        <Box mt={2}>
            {loading ? (
                <CircularProgress size={28} />
            ) : ratingResult ? (
                <Typography variant="subtitle1" color="primary">
                    Fatura Tutarı: {formatCurrency(ratingResult.totalCharge)} TL
                </Typography>
            ) : 
            <Typography variant="subtitle1" color="primary">
                    Fatura Tutarı: {formatCurrency(amount)} TL
                </Typography>
            }
        </Box>
    );
};

export default MainMeterRatingCalculator;
